const MembersManagement: React.FC = () => {
  return (
    <>
      <h1>MembersManagement</h1>
    </>
  );
};

export default MembersManagement;
